import { TutorialDefinition, TutorialScene } from '../TutorialEngine.js';
import { COLORS } from '../../rendering/Renderer.js';
import { SplittingVortexTutorialState } from './SplittingTutorialAdapter.js';

type VState = SplittingVortexTutorialState;

const PARTIAL = 'C0,A4';
const PARTIAL_GATED = `${PARTIAL}|D4=E2`;
const SOLVED = 'C0,A4,F1|D4=E2';

const scenes: TutorialScene[] = [
    // Scene 1: Toggle Gates — animate the gate placement flow
    {
        gameState: { splitting: PARTIAL } as VState,
        renderOptions: {},
        annotations: [
            { type: 'text-label', text: 'Click Activate Vortex\nto place a gate pair', cell: 'C2', anchor: 'center' },
            { type: 'text-label', text: 'Pair must be linked\nin the Vortex Hub', cell: 'D5', anchor: 'center' },
        ],
        animate: {
            interval: 1500,
            loop: true,
            frames: [
                { splitting: PARTIAL },
                { splitting: PARTIAL, gateMode: true },
                { splitting: PARTIAL_GATED, gateMode: true },
                { splitting: PARTIAL_GATED },
            ] as VState[],
        },
    },

    // Scene 2: Activation — toggle an unblocked pair active; a blocked pair stays amber
    {
        gameState: { splitting: 'B5', gateMode: true, extraGates: [['B5', 'D5']] } as VState,
        renderOptions: {},
        annotations: [
            { type: 'text-label', text: 'Click a pair\nto activate it', cell: 'E3', anchor: 'center', color: COLORS.teal },
            { type: 'text-label', text: 'Splitters block\ngate activation', cell: 'B5', anchor: 'far-above', color: COLORS.amber },
        ],
        animate: {
            interval: 1500,
            loop: true,
            frames: [
                { splitting: 'B5', gateMode: true, extraGates: [['B5', 'D5']] },
                { splitting: 'B5|D4=E2', gateMode: true, extraGates: [['B5', 'D5']] },
            ] as VState[],
        },
    },

    // Scene 3: Beam teleportation
    {
        gameState: { splitting: PARTIAL_GATED } as VState,
        renderOptions: {},
        annotations: [
            { type: 'text-label', text: 'Beams enter\na gate...', cell: 'D5', anchor: 'center' },
            { type: 'text-label', text: '...and exit from\nthe other side', cell: 'E3', anchor: 'center' },
            { type: 'pulse', cell: 'D4', color: COLORS.purple },
            { type: 'pulse', cell: 'E2', color: COLORS.purple },
        ],
    },

    // Scene 4: Full solved state
    {
        gameState: { splitting: SOLVED } as VState,
        renderOptions: {},
        annotations: [
            { type: 'text-label', text: 'Gate pairs\ncan be reused', cell: 'C2', anchor: 'center', color: COLORS.amber },
            { type: 'pulse', cell: 'D4', color: COLORS.purple },
            { type: 'pulse', cell: 'E2', color: COLORS.purple },
        ],
    },
];

/**
 * Vortex Splitting tutorial: 4 scenes on a 6×6 vortex grid with digits 0-3.
 * Teaches beam teleportation through Vortex gates.
 */
export const SPLITTING_VORTEX_TUTORIAL: TutorialDefinition = {
    gameType: 'splitting-vortex',
    gridCode: '6/0-3:0C4,1F2,2A3,3D1',
    scenes,
    previewScene: 3,
};
